import { ReactNode } from 'react';

import { PlayLineup as CoreLineup } from '@sorare/core/src/components/rivals/PlayLineupBox/PlayLineup';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';

import { FootballLineup } from 'components/rivals/PlayLineupBox/FootballLineup';

type Props = { children: ReactNode; extraInfo?: boolean };

export const PlayLineup = ({ children, extraInfo }: Props) => {
  const isTabletAndAbove = useIsTabletAndAbove();

  return isTabletAndAbove ? (
    <FootballLineup extraInfo={extraInfo}>{children}</FootballLineup>
  ) : (
    <CoreLineup>{children}</CoreLineup>
  );
};
